<script setup>
import { ref, reactive, onMounted } from "vue";
import {
  editStoreMemberApplications,
  editStoreMemberApplicationsNew,
  listStoreMemberApplications,
} from "@/api/storeMemberApplications/storeMemberApplications.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTAuditUserDialog from "@/components/YTAuditUserDialog/index.vue";
import YTGender from "@/components/YTGender/index.vue";
import router from "@/router/index.js";
import YTClubUserAuditState from "@/components/YTClubUserAuditState/index.vue";
import { clubUserAuditStateEnum } from "@/enum/clubUserAuditStateEnum.js";
import {Clock} from "@element-plus/icons-vue";

/*初次加载*/
onMounted(async () => {
  await handleSearch();
});

/*过滤器相关功能*/
// 过滤器表单
const formData = reactive({
  nickname: null,
  time: [],
  state: null,
  stateList: ["APPROVED", "REJECTED"],
});
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === "btnSearch") YTTablePaginationRef.value.resetPage();
  try {
    const param = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize(),
    };
    loading.value = true;
    let formDataParam = {
      nickname: formData.nickname,
      startCrTime: formData.time ? formData.time[0] : null,
      endCrTime: formData.time ? formData.time[1] : null,
      state: formData.state,
      stateList: formData.stateList,
    };
    const res = await listStoreMemberApplications(param, formDataParam);
    tableData.value = [];
    tableData.value = res.list;
    total.value = parseInt(res.total);
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};
// 清空表单内容
const handleReset = () => {
  formData.nickname = null;
  formData.time = [];
  formData.state = null
  handleSearch("btnSearch");
};

/*表格相关功能*/
// 表格加载状态
const loading = ref(false);
// 表格数据
const tableData = ref([]);
// 表格数据总条数
const total = ref(0);
// 翻页组件锚点
const YTTablePaginationRef = ref();
// 处理翻页
const handleChangePage = () => {
  handleSearch();
};

/*操作栏相关功能*/

/*审核弹窗相关功能*/
// 审核弹窗锚点
const YTAuditUserDialogRef = ref();
// 审核弹窗类型
const auditType = ref("reject");
const auditCacheData = ref();
// 处理点击了拒绝
const handleClickReject = (info) => {
  console.log("handle click");
  auditCacheData.value = info;
  auditType.value = "reject";
  YTAuditUserDialogRef.value.handleOpen();
  YTAuditUserDialogRef.value.handleChangeRules("reject");
};
// 处理点击了通过
const handleClickPass = (info) => {
  auditCacheData.value = info;
  auditType.value = "pass";
  YTAuditUserDialogRef.value.handleOpen();
  YTAuditUserDialogRef.value.handleChangeRules("pass");
  handleApproved(info);
};
// 同意会员申请
const handleApproved = async (item) => {
  try {
    let param = {
      id: item.id,
      state: "APPROVED",
    };
    await editStoreMemberApplicationsNew(param);
  } catch (err) {
    console.log(err);
  }
};
// 处理编辑会员弹窗修改成功/审核拒绝成功（通过后需要修改用户信息）
const handleUpdateSuccess = () => {
  YTAuditUserDialogRef.value.handleClose();
  handleSearch();
};

const jumpToHistory = () => {
  router.push("/store/listUserHistoryAudit");
};
</script>

<template>
  <div class="new_container_box">
    <div class="table_filter_box flex_bt mg_b_2">
      <div class="table_filter_title">
        <!-- TODO 暂时不用，先隐藏 -->
        <!--        <v-btn color="#796CB4" @click="handleReset">-->
        <!--          <template v-slot:prepend>-->
        <!--            <img style="width: 20px;height: 14px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/batch.svg">-->
        <!--          </template>-->
        <!--          <template v-slot:default>-->
        <!--            <span>批量处理</span>-->
        <!--          </template>-->
        <!--        </v-btn>-->
      </div>
      <div class="flex">
        <el-input
          v-model="formData.nickname"
          :class="
            formData.nickname === null || formData.nickname === ''
              ? 'input-null mg_r_2'
              : 'input-filled mg_r_2'
          "
          style="width: 170px"
          placeholder="会员昵称"
        >
        </el-input>

        <div
          :class="
            formData.time?.length === 0 || formData.time === null
              ? 'input-null mg_r_2'
              : 'input-filled mg_r_2'
          "
        >
          <el-date-picker
            :teleported="false"
            v-model="formData.time"
            type="daterange"
            range-separator="至"
            start-placeholder="申请时间开始"
            end-placeholder="申请时间结束"
            style="width: 270px"
            :prefix-icon="Clock"
          />
        </div>

        <el-select
          :suffix-icon="$SelectArrowDown"
          collapse-tags
          :teleported="false"
          v-model="formData.state"
          :class="!formData.state ? 'input-null' : 'input-filled'"
          style="width: 170px"
          placeholder="审核状态"
        >
          <el-option
            v-for="item in clubUserAuditStateEnum"
            v-show="item.stateId !== 'PENDING'"
            :key="item.stateId"
            :label="item.stateName"
            :value="item.stateId"
          >
            <template #default>
              <div class="flex_bt">
                <div class="option-label">{{ item.stateName }}</div>
                <img
                  v-if="formData.state && formData.state === item.stateId"
                  style="width: 13px; height: 13px"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                />
              </div>
            </template>
          </el-option>
        </el-select>

        <v-btn
          style="margin-right: 15px; margin-left: 40px"
          color="#4CAF50"
          @click="handleSearch('btnSearch')"
          >搜索</v-btn
        >
        <v-btn color="#d7d7df" @click="handleReset">重置</v-btn>
      </div>
    </div>
    <div style="margin-bottom: 25px">
      <el-table
        :data="tableData"
        :border="false"
        style="width: 100%"
        :header-row-style="{ color: '#272539' }"
        :row-style="{ color: '#656565' }"
        v-loading="loading"
        stripe
      >
        <el-table-column prop="avatar" label="会员头像" align="center">
          <template #default="scope">
            <img
              style="width: 34px; height: 34px; border-radius: 34px"
              :src="
                scope.row.avatar
                  ? scope.row.avatar
                  : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'
              "
            />
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="会员昵称">
          <template #default="scope">
            <span>{{ scope.row.nickname ? scope.row.nickname : "—" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别">
          <template #default="scope">
            <YTGender :gender="scope.row.gender"></YTGender>
          </template>
        </el-table-column>
        <el-table-column prop="carBrand" label="车辆品牌">
          <template #default="scope">
            <span>{{ scope.row.carBrand ? scope.row.carBrand : "—" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ftp" label="FTP">
          <template #default="scope">
            <span>{{ scope.row.ftp ? scope.row.ftp + "W" : "—" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话">
          <template #default="scope">
            <span>{{ scope.row.phone ? scope.row.phone : "—" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="crTime" label="审核时间" sortable width="180">
          <template #default="scope">
            <span>{{ scope.row.mdTime ? scope.row.mdTime : "—" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="crTime" label="审核状态" width="180">
          <template #default="scope">
            <YTClubUserAuditState
              :state="scope.row.state"
              v-if="!loading"
            ></YTClubUserAuditState>
          </template>
        </el-table-column>
        <el-table-column prop="crTime" label="通过备注/拒绝理由" width="180">
          <template #default="scope">
            <span>{{ scope.row.reason ? scope.row.reason : "—" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pd_b_4" style="padding-right: 20px">
      <YTTablePagination
        ref="YTTablePaginationRef"
        :pageSize="$globalPageSize"
        :total="total"
        @page-change="handleChangePage"
      ></YTTablePagination>
    </div>
  </div>
  <YTAuditUserDialog
    ref="YTAuditUserDialogRef"
    :type="auditType"
    :audit-cache-date="auditCacheData"
    @reject="handleUpdateSuccess"
    @success="handleUpdateSuccess"
  ></YTAuditUserDialog>
</template>

<style scoped></style>
